var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImageFreeTrial = function SvgImageFreeTrial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 67 74"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Image_FreeTrial_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#Image_FreeTrial_svg__b)",
    d: "M5.21 67.042a5.8 5.8 0 0 1-1.458-5.61l6.467-23.575L34.293 62.23 10.68 68.538a5.64 5.64 0 0 1-5.47-1.496"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004761",
    fillOpacity: 0.5,
    d: "m21.077 65.772-7.202-18.958 8.848 4.375 4.526 12.916zM15.523 67.23l-3.91 1.041-6.996-9.999 3.498-12.707z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00C499",
    d: "M28.242 43.98c6.75 6.834 9.942 14.682 7.13 17.53-2.813 2.847-10.565-.385-17.314-7.218s-9.942-14.682-7.13-17.53c2.813-2.847 10.564.385 17.314 7.218"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Image_FreeTrial_svg__c)",
    d: "M27.66 44.57c6.429 6.508 9.62 13.828 7.13 16.35-2.492 2.522-9.722-.71-16.15-7.218-6.429-6.508-9.62-13.828-7.13-16.35 2.491-2.522 9.722.71 16.15 7.217"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    d: "M53.517 70.92c-5.797 1.745-12.785-3.237-11.367-11.417.448-2.585 2.011-4.875 4.088-6.716-6.484-1.551-11.96.59-15.648 2.873a1.226 1.226 0 0 1-1.697-.414 1.26 1.26 0 0 1 .409-1.719c4.368-2.704 11.274-5.357 19.455-2.614.593-.37 1.204-.71 1.824-1.014 4.038-1.984 8.951-2.78 12.563-1.16.624.28.905 1.017.629 1.649a1.23 1.23 0 0 1-1.629.636c-2.672-1.198-6.77-.702-10.485 1.124l-.068.035c3.307 1.939 5.93 5.2 7.013 8.487.666 2.019.79 4.173-.013 6.073-.82 1.94-2.519 3.409-5.074 4.178m-8.935-10.985c-1.096 6.323 4.167 9.813 8.231 8.59 1.991-.6 3.029-1.633 3.508-2.765.495-1.173.48-2.664-.06-4.299-1.03-3.126-3.831-6.318-7.187-7.764-2.397 1.733-4.094 3.944-4.492 6.238"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M44.078 36.242c.838-.512 1.94-.217 2.46.658.522.875.265 2-.574 2.51-.838.512-3.078.912-3.599.037-.52-.875.875-2.694 1.713-3.205"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00C499",
    d: "M24.365 54.267c0 1.362-1.09 2.466-2.436 2.466s-2.437-1.104-2.437-2.466S20.583 51.8 21.93 51.8s2.436 1.104 2.436 2.467"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.155 21.583c0 1.022-.819 1.85-1.828 1.85a1.84 1.84 0 0 1-1.827-1.85c0-1.021.818-1.85 1.827-1.85 1.01 0 1.828.829 1.828 1.85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0",
    d: "M15.838 27.75c0 1.022-.818 1.85-1.827 1.85a1.84 1.84 0 0 1-1.827-1.85c0-1.021.818-1.85 1.827-1.85s1.827.829 1.827 1.85"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FC3D3D",
    d: "M25.333 5.556a1.25 1.25 0 0 1 1.023-1.432 1.236 1.236 0 0 1 1.415 1.036c2.477 15.615-4.05 32.012-9.163 39.487a1.225 1.225 0 0 1-1.717.316 1.26 1.26 0 0 1-.312-1.739c4.864-7.113 11.102-22.868 8.754-37.668"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.06 29.18a1.233 1.233 0 0 1 1.526-.858c.656.19 1.035.882.848 1.545-2.149 7.612-6.659 12.593-10.32 16.028-.5.469-1.281.439-1.745-.068a1.26 1.26 0 0 1 .067-1.765c3.526-3.309 7.656-7.912 9.624-14.882"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Image_FreeTrial_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-9.74545 29.2917 -25.5788 -8.72319 15.228 38.85)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.118,
    stopColor: "#004761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C499"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Image_FreeTrial_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(2.67294 -12.3853 37.9544 21.4048 23.772 58.112)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004761"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#00C499"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Image_FreeTrial_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h67v74H0z"
  })))));
};
export default SvgImageFreeTrial;